import { createAuth0 } from "@auth0/auth0-vue";
import { createRedirectUri } from "./redirect-uri";

const redirect_uri = createRedirectUri(
  process.env.VUE_APP_PACKAGE_ID,
  process.env.VUE_APP_AUTH0_DOMAIN
);
console.log("redirect_url" + redirect_uri);

export const auth0 = createAuth0(
  {
    domain: process.env.VUE_APP_AUTH0_DOMAIN,
    clientId: process.env.VUE_APP_AUTH0_CLIENT_ID,
    authorizationParams: {
      redirect_uri,
      audience: process.env.VUE_APP_AUTH0_AUDIENCE,
    },
    cacheLocation: "localstorage",
    useRefreshTokens: true,
  },
  {
    skipRedirectCallback: true,
  }
);
